import { FC, useRef } from 'react'
import { NavLink } from 'react-router-dom'
import Logo from 'shared/Logo/Logo'
import SwitchDarkMode from 'shared/SwitchDarkMode/SwitchDarkMode'

import AvatarDropdown from './components/AvatarDropdown'
import { HeaderProps } from './types'

const itemLink = [
  {
    title: 'Home',
    link: '/home',
  },
  {
    title: 'Colaboradores',
    link: '/employees',
  },
  {
    title: 'Premiação',
    link: '/rewards',
  },
]

export const Header: FC<HeaderProps> = ({ className = '', searchEngine }) => {
  const headerInnerRef = useRef<HTMLDivElement>(null)

  return (
    <header
      ref={headerInnerRef}
      className={`sticky top-0 z-40 bg-white dark:bg-neutral-900 ${className}`}
    >
      <div className="relative px-4 lg:container h-[88px] flex">
        <div className="flex-1 flex items-center justify-between">
          <div className="relative z-10 hidden md:flex flex-1 items-center gap-16">
            <NavLink to="/home">
              <Logo searchEngine={searchEngine} />
            </NavLink>
            {searchEngine && (
              <div className="flex items-center space-x-6">
                {itemLink.map((item) => (
                  <NavLink
                    key={`nav-link-${item.title}`}
                    to={item.link}
                    className={({ isActive }) =>
                      isActive
                        ? 'text-neutral-900 dark:text-neutral-100 rounded-full bg-neutral-200 dark:bg-neutral-800 px-4 py-2'
                        : 'text-neutral-500 dark:text-neutral-300 hover:text-neutral-700 dark:hover:text-neutral-100 px-4 py-2'
                    }
                  >
                    {item.title}
                  </NavLink>
                ))}
              </div>
            )}
          </div>
          {searchEngine && (
            <div className="hidden md:flex relative z-10 flex-1 items-center justify-end text-neutral-700 dark:text-neutral-100">
              <div className="items-center flex space-x-1">
                <SwitchDarkMode />
                <AvatarDropdown />
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}
